module.exports = __webpack_public_path__ + "static/media/video-banner.abeae402.jpg";